var _excluded = ["children", "variant", "icon", "iconPlacement", "hideLabel", "sizeVariant", "fullWidth", "compact", "dangerouslySetClassNames", "as"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
import LinkBase from "./LinkBase";
import forwardRef from "../../private/forwardRef";
// WARNING: This component is not self contained!
// It depends on the relative file path below and is therefore NOT portable
import ButtonBase from "../Button/ButtonBase";
var LinkWithButtonVariant = styled(ButtonBase).withConfig({
  displayName: "Link__LinkWithButtonVariant",
  componentId: "sc-t5cqk8-0"
})(["text-decoration:none;display:flex;text-align:center;justify-content:center;width:", ";"], _ref => {
  var {
    $fullWidth
  } = _ref;
  return $fullWidth ? "100%" : "fit-content";
});
var SpanWithMargin = styled.span.withConfig({
  displayName: "Link__SpanWithMargin",
  componentId: "sc-t5cqk8-1"
})(["", ";"], _ref2 => {
  var {
    $iconPlacement,
    $buttonVariantMatches,
    theme
  } = _ref2;
  return "margin-" + $iconPlacement + ": " + ($buttonVariantMatches ? theme.spacing.extraSmall : theme.spacing.twoExtraSmall);
});
var IconWrapper = styled.span.withConfig({
  displayName: "Link__IconWrapper",
  componentId: "sc-t5cqk8-2"
})(["display:inline-flex;vertical-align:text-top;"]);

/**
 * Text links should be used as navigational components which direct the user to a new screen. Do not confuse links with buttons, which are used to indicate an action will be performed.
 *
 * @see [Link documentation](https://construct-kit.reainternal.net/components/web/core/link)
 */
var Link = forwardRef((_ref3, ref) => {
  var {
      children,
      variant = "primary",
      icon,
      iconPlacement = "left",
      hideLabel = false,
      sizeVariant = "large",
      fullWidth = false,
      compact = false,
      dangerouslySetClassNames,
      as
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded);
  var buttonVariantMatches = variant.match(/button-(.*)/);
  var variantName = buttonVariantMatches ? buttonVariantMatches[1] : variant;
  var renderIcon = () => {
    if (icon) {
      return buttonVariantMatches ? icon : /*#__PURE__*/React.createElement(IconWrapper, {
        className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.iconWrapper
      }, icon);
    }
  };
  var renderChildren = () => icon ? /*#__PURE__*/React.createElement(SpanWithMargin, {
    $iconPlacement: iconPlacement,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.label,
    $buttonVariantMatches: !!buttonVariantMatches
  }, children) : children;
  var commonProps = _extends({
    "aria-label": hideLabel && typeof children === "string" ? children : undefined,
    $variant: variantName,
    $fullWidth: fullWidth,
    $compact: compact,
    $sizeVariant: sizeVariant,
    ref
  }, props);
  var renderIconAndLabel = () => /*#__PURE__*/React.createElement(React.Fragment, null, iconPlacement === "left" && renderIcon(), !hideLabel ? renderChildren() : null, iconPlacement === "right" && renderIcon());
  return buttonVariantMatches ? /*#__PURE__*/React.createElement(LinkWithButtonVariant, _extends({
    as: as || "a"
  }, commonProps), renderIconAndLabel()) : /*#__PURE__*/React.createElement(LinkBase, _extends({
    as: as
  }, commonProps), renderIconAndLabel());
});
Link.displayName = "Link";
export default Link;
export { LinkBase };